<template>
  <div class="head">
    <div class="footerContent">
      <div>主办单位：中国铁道工程建设协会     地址：北京市复兴路10号</div>
      <div>邮编：100844   电话：(010)51847442   传真：(010)51847442   备案号：京ICP备13011762号-4</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style>
.head {
  width: 100%;
  height: 90px;
  line-height: 27px;
  background-color: #094895;
  color: #d8e1f1;
  font-size: 16px;
}
.footerContent{
  width: 1200px;
  margin: 0 auto ; 
  padding-top: 17px;
}
</style>
